import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { useWorkspace } from "@/contexts/WorkspaceContext";
import { toast } from "sonner";

export default function CreateWorkspaceDialog({ open, onOpenChange }) {
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);
  const { refreshWorkspaces, switchWorkspace } = useWorkspace();

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    setBusy(true);
    try {
      const { data } = await api.post("/workspaces", { name: name.trim() });
      toast.success("Workspace created");
      await refreshWorkspaces();
      switchWorkspace(data.workspace.id);
      setName("");
      onOpenChange(false);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Failed to create workspace");
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="rounded-sm" data-testid="create-workspace-dialog">
        <DialogHeader>
          <DialogTitle className="font-display tracking-tight">New workspace</DialogTitle>
        </DialogHeader>
        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <Label className="font-mono-data text-[10px] uppercase tracking-[0.2em] text-neutral-500">Name</Label>
            <Input
              autoFocus
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Acme Operations"
              className="mt-1 rounded-sm h-10"
              data-testid="create-workspace-name-input"
            />
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)} className="rounded-sm">Cancel</Button>
            <Button type="submit" disabled={busy || !name.trim()} className="rounded-sm bg-neutral-950 hover:bg-neutral-800" data-testid="create-workspace-submit">
              {busy ? "Creating…" : "Create workspace"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
